import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

import './_timeline.scss';

const TIMELINE_SECTION_SELECTOR = '.timeline';
const TIMELINE_ITEM_SELECTOR = '.timeline-item';
const TIMELINE_ITEM_IMAGE_SELECTOR = '.timeline-item__image-wrapper';
const TIMELINE_ITEM_CONTENT_SELECTOR = '.timeline-item__content';
const IMAGE_MAX_HEIGHT = 375;

const handleImageScroll = (section) => {
    const images = section.querySelectorAll(TIMELINE_ITEM_IMAGE_SELECTOR);

    images.forEach((image) => {
        ScrollTrigger.create({
            trigger: image,
            start: 'top 90%',
            end: 'top 25%',
            once: true,
            scrub: true,
            animation: gsap.fromTo(image, {
                y: 200,
                opacity: 0,
            }, 
            {
                y: 0,
                opacity: 1,
            }),
            onLeave: () => {
                const childImage = image.querySelector('.background-image');
                childImage.style.transform = 'scale(1)';
            }
        });
    }); 
};

const handleNoImages = (section) => {
    const timelineItems = section.querySelectorAll(TIMELINE_ITEM_SELECTOR);

    timelineItems.forEach((item) => {
        const timelineItemContent = item.querySelector(TIMELINE_ITEM_CONTENT_SELECTOR);
        const timelineItemImage = item.querySelector(TIMELINE_ITEM_IMAGE_SELECTOR);
        const timelineItemContentHeight = timelineItemContent.offsetHeight;

        if (!timelineItemImage && timelineItemContent) {
            item.style.minHeight = timelineItemContentHeight + 'px';
        }
    });
};

const handleOversizedText = (section) => {
    const timelineItems = section.querySelectorAll(TIMELINE_ITEM_SELECTOR);

    timelineItems.forEach((item) => {
        const timelineItemContent = item.querySelector(TIMELINE_ITEM_CONTENT_SELECTOR);
        const timelineItemContentHeight = timelineItemContent.offsetHeight;

        if (timelineItemContentHeight > IMAGE_MAX_HEIGHT) {
            item.style.minHeight = timelineItemContentHeight + 'px';
        }
    });
};

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);

    const sections = document.querySelectorAll(TIMELINE_SECTION_SELECTOR);

    sections.forEach((section) => {
        handleImageScroll(section);
        handleNoImages(section);
        handleOversizedText(section);
    });
});

let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
        const sections = document.querySelectorAll(TIMELINE_SECTION_SELECTOR);

        sections.forEach((section) => {
            handleOversizedText(section);
        });
    }, 100);
});
